<template>
  <div class="fullscreen">
    <div id="scroll-div-shelf" class="main scroll-list" style="z-index: 1; height: calc(100vh - 50px);">
      <div class="bookshelfbar flex">
        <a :class="{active: getActive() === 'shelf'}" @click="toShelf">漫画收藏</a>
        <a :class="{active: getActive() === 'history'}" @click="toHistory">阅读记录</a>

        
        
      </div>
      <div style="width: 100%; height: 2.5rem;"></div>

      <div v-if="activated === 'shelf'">
        <books-small :title="`漫画收藏${shelfList.length}）`" :show-more="false"
                   :singleMode="true" :atShelf="true" :books="shelfList"></books-small>
      </div>
      <div  v-else-if="activated === 'history'">
        <books-small :title="'最近浏览'" :show-more="false"
                   :singleMode="true" :books="historyList"></books-small>
      </div>
      <div  v-else-if="activated === 'shelf-vod'">
        <vod-list  :show-title="false" :vodData="shelfVodList"></vod-list>
      </div>
      

      <loading ref="loading" scroll-div="scroll-div-shelf" :is-loading="isLoading" :is-no-more-data="isNoMoreData" @get-books="loadShelfVod(page + 1)"></loading>


    </div>
    <a id="shelfReportUrl" class="fixed-ts" style="z-index: 10"><span>投诉</span></a>
    <bottom></bottom>
  </div>
</template>

<script>
import BooksSmall from '@/components/share/books-small'
import Bottom from '@/components/layer1/bottomIndex'
import vodService from "../../services/vodService";
import shelfService from "../../services/shelfService";
import userService from "../../services/userService";
import VodList from '@/components/share/vod-list.vue'
import Loading from "../../components/share/loading";

import {getReportUrl} from "../../services/urlService";

export default {
  name: "shelf",
  data() {
    return {
      userInfo: null,
      componentName: '',
      activated: 'shelf',
      shelfList: [],
      historyList: [],
      shelfVodList: [],
      page: 1,
      nextPage: false,
      listData: '',
      totalCount: 0,
      totalPage: 0,
      isLoading: false,
      isNoMoreData: false,
    }
  },
  methods: {
    getActive() {
      return this.activated;
    },
    toShelf() {
      this.activated = 'shelf';
      this.loadShelf();
      //this.$router.push({path: '/shelf', query: {active: 'shelf'}})
    },
    toHistory() {
      this.activated = 'history';
      this.loadHistory();
      //this.$router.push({path: '/shelf', query: {active: 'history'}})
    },
    toShelfVod(){
      this.activated = 'shelf-vod';
    },
    loadShelf() {
      this.shelfList = []
      this.historyList = []
      this.shelfList = shelfService.getShelf();
    },
    loadHistory() {
      this.shelfList = []
      this.historyList = []
      this.historyList = shelfService.getHistory().map(item => item.bookInfo);
    },
    loadShelfVod() {
      this.isLoading = true;
      this.isNoMoreData = false;
      vodService.getVodShelf(this.page).then(res => {
        if (res.data){
          this.totalCount = res.data.totalCount
          this.totalPage = res.data.totalPage
          this.isLoading = false;
          if (res.data.totalPage === 0) {
            this.isNoMoreData = true;
            this.shelfVodList = []
          } else if (this.page === 1) {
            this.shelfVodList = res.data.list;
          } else if (this.page > 1 && this.page <= res.data.totalPage) {
            this.shelfVodList.push(...res.data.list);
          }
          if (res.data.totalPage == 0 || this.page >= res.data.totalPage) {
            this.isNoMoreData = true;
          }
        }
        setTimeout(() => {
            this.$refs['loading'].scrollFunction();
          }, 0)
      });
    },
  },
  components: {
    'books-small': BooksSmall,
    'vod-list': VodList,
    bottom: Bottom,
    loading: Loading,
  },
  mounted() {
    this.userInfo = userService.getLocalUserInfo();
    if (this.userInfo == null) {
      document.getElementById("shelfReportUrl").href = getReportUrl(null);
    } else {
      document.getElementById("shelfReportUrl").href = getReportUrl(this.userInfo.account);
    }
    this.componentName = this.$route.name;
    if (this.$store.state.pageState[this.componentName] && this.$router.isBack) {
      Object.assign(this.$data, this.$store.state.pageState[this.$route.name].data);
      setTimeout(() => {
        let scrollDiv = document.getElementById('scroll-div-shelf');
        console.log(this.$store.state.pageState[this.$route.name].top);
        scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top;
      }, 0);
    } else {
      this.loadShelf();
      this.loadHistory();
      this.loadShelfVod();

      if (this.$route.query.active === 'shelf') {
        this.activated = 'shelf';
        this.loadShelf();
      }
      if (this.$route.query.active === 'history') {
        this.activated = 'history';
        this.loadHistory();
      }
      if (this.$route.query.active === 'shelf-vod') {
        this.activated = 'shelf-vod';
        this.loadShelfVod()
      }
    }
    this.$router.isBack = true;
  },
  beforeDestroy() {
    let scrollDiv = document.getElementById('scroll-div-shelf');
    let state = {};
    state[this.componentName] = {data: this.$data, top: scrollDiv.scrollTop}
    this.$store.commit('saveState', state);
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/layer1/shelf.vue